import React from 'react';
import { 
    Container, 
    Sticker,
    CaseLink,
    // CaseStudyContainerList,
    // CaseStudyContainer,
    // CaseStudyContentList,
    // CaseStudyContent,
    // ContainerList
} from '../StyledComponents/StyledComponents';
import { useEffect, useState } from 'react';
import marked from 'marked';

import { Fade } from 'react-awesome-reveal';

import AboutContent from '../../posts/about.md';
import climateReality from '../../assets/img/climatereality.png'
import ea from '../../assets/img/ea.png'
import risc from '../../assets/img/risc.png'
import PD_logo_Teal from '../../assets/img/PD_logo_Teal.png'
// import { PALETTE_3 } from '../../assets/colors';

const Resume = () => {

    const [, setMarkdown] = useState({});
    const [cR, setCR] = useState(false);
    const [eA, setEA] = useState(false);
    const [RISC, setRISC] = useState(false);
    const onHover = (setHover) => {
        setHover(true);
    };

    const onHoverOver = (setHover) => {
        setHover(false);
    };

    // const [open, setOpen] = useState(false);

    // const toggle = () => {
    //     setOpen(!open);
    // }

    //const [markdownContent, setMarkdownContent] = useState('');

    // useEffect(() => {
    //     console.log("Fetching Markdown")
    //     const fetchMarkdown = async () => {
    //     try {
    //         console.log("FETCHING MARKDOWN")
    //         const response = await fetch('../../../curriculum_vitae.md'); // Update the path
    //         const text = await response.text();
    //         setMarkdownContent(text);
    //     } catch (error) {
    //         console.error('Error fetching markdown file:', error);
    //     }
    //     };

    //     fetchMarkdown();
    // }, []);

    // const getMarkdownText = () => {
    //     console.log("GET MARKDOWN TEXT")
    //     const rawMarkup = marked(markdownContent, { sanitize: false });
    //     console.log(markdownContent)
    //     return DOMPurify.sanitize(rawMarkup);
    //   };

    useEffect(() => {
        fetch(AboutContent)
            .then(response => {
                return response.text()
            })
            .then(text => {
                setMarkdown(marked(text))
        })
    }, [])

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://platform.twitter.com/widgets.js";
        if (document.getElementsByClassName("twitter-embed")[0]) {
            document.getElementsByClassName("twitter-embed")[0].appendChild(script);
        }
    }, []);

    return (
        <Container>
            {/* Background */}
            <Container flex bottom={6}>
                <Container width={20} right={3} bottom={3}>
                    <h1>About</h1>
                    <div>
                    <Sticker src={climateReality} 
                        style={{width: "20%", maxWidth: "50px", marginRight: "5%", justifyContent: "center"}} 
                        onMouseEnter={() => onHover(setCR)}
                        onMouseLeave={() => onHoverOver(setCR)}
                    />
                    <Sticker 
                        src={ea} style={{width: "20%", maxWidth: "50px", marginRight: "5%"}}
                        onMouseEnter={() => onHover(setEA)}
                        onMouseLeave={() => onHoverOver(setEA)}/>
                    <Sticker 
                        src={risc} style={{width: "20%", maxWidth: "50px", marginRight: "5%"}}
                        onMouseEnter={() => onHover(setRISC)}
                        onMouseLeave={() => onHoverOver(setRISC)}/>
                    </div>
                    {cR && <i style={{lineHeight: ".75", margin: "0", fontSize: "15px"}}>Climate Reality Leader</i>}
                    {eA && <i style={{lineHeight: ".75", margin: "0", fontSize: "15px"}}>Effective Altruist</i>}
                    {RISC && <i style={{lineHeight: ".75", margin: "0", fontSize: "15px"}}>RISCer</i>}
                    
                </Container>
                <Container width={80}>
                    <p>
                        I completed my undergrad in CS + Stat and Masters in Computer Science in 2024 with high honors, both from Harvard. 
                        You can check out some of the things I've been thinking about (<a href="/blog">here</a>), 
                        like eligibility support for living kidney donors (<a href="https://projectdonor.org">Project Donor</a>).
                    </p>

                    <Fade direction="top" duration={1000} triggerOnce cascade>
                        <CaseLink target={null} styles={{justifyContent: 'center'}} />
                    </Fade>

                    <h2 style={{ marginTop: "2.5rem", marginBottom: "1.5rem" }}>Current Focus</h2>
                    <div style={{ 
                        background: 'rgba(255, 255, 255, 0.05)', 
                        padding: '2rem', 
                        borderRadius: '8px',
                        marginBottom: '2rem'
                    }}>
                        <p style={{ textAlign: 'center', fontSize: '1.2em', marginBottom: '1.5rem' }}>
                            I am the co-director of <a href="https://www.projectdonor.org/">Project Donor</a>
                        </p>
                        <img 
                            src={PD_logo_Teal} 
                            alt="Project Donor Logo" 
                            style={{
                                width: "50%", 
                                maxWidth: "300px", 
                                margin: "20px auto", 
                                display: "block"
                            }}
                        />
                        <p>At Project Donor, we identify individuals on the cusp of kidney donation eligibility, and provide them with the resources they need to become living kidney donors. 
                            We do this notably efficiently, at <b>8x the national donation conversion rate</b> and saving lives at costs <b><a href="https://forum.effectivealtruism.org/posts/sDLvkLMhmmatiqaR7/introducing-project-donor-a-cost-effective-approach-to">cheaper than GiveWell</a></b>.
                        </p>
                        <p>
                            At Project Donor, I build platforms and analyze data to optimize our operations, inform strategic decisions, and ultimately ensure we’re saving as many lives as possible.
                        </p>
                        <p>We are housed at The Center for <a href="https://risc.uchicago.edu/">Radical Innovation for Social Change</a> at UChicago.</p>
                    </div>

                    <h2 style={{ marginBottom: "1rem" }}>Professional Experience</h2>
                    <ul style={{ 
                        listStyleType: 'none', 
                        padding: 0,
                        margin: 0
                    }}>
                        <li style={{ marginBottom: '1rem' }}>• At the <a href="https://mobility.mit.edu/">MIT Mobility Lab</a>, I researched mobility of care patterns.</li>
                        <li style={{ marginBottom: '1rem' }}>• I worked as an Investment Engineer on the Sustainability Team at Bridgewater in 2023.</li>
                        <li style={{ marginBottom: '1rem' }}>• I predicted global population migration patterns and worked with global carbon emissions projections at the World Data Lab in Vienna (<a href="https://worlddata.io/">WDL</a>).</li>
                        <li style={{ marginBottom: '1rem' }}>• I spent my 2021 summer working at Facebook Reality Labs in New York.</li>
                        <li style={{ marginBottom: '1rem' }}>• At <a href="https://www.adaviv.site/">Adaviv</a>, an indoor farming technology company, I spent my gap year building a yield forecasting algorithm.</li>
                        <li style={{ marginBottom: '1rem' }}>• I interned at Microsoft AI & Research wing in Bing Maps and virtual reality technology.</li>
                    </ul>
                </Container>
            </Container>
            {/* CV
            <Container flex bottom={6} style={{marginTop: "5%"}}>
                <h1>Curriculum Vitae</h1>
            </Container>
            <Container flex bottom={6}>
                <Container width={50}>
                    <div dangerouslySetInnerHTML={{ __html: getMarkdownText() }} />
                </Container>
            </Container> */}
            {/* Korean */}
            <Container flex bottom={6} style={{marginTop: "3rem"}}>
                <div style={{ width: '100%' }}>
                    <h2 style={{ marginBottom: "1.5rem" }}>한국어</h2>
                    <p style={{ fontSize: '1.1em', lineHeight: '1.6' }}>
                        <u><a href="https://www.youtube.com/embed/1GWdqd-S6iE">2학기 동안</a></u> 공부했어요. 저는 한국 음악을 듣는 것을 좋아해요.
                    </p>
                </div>
            </Container>
            {/* Piano */}
            <Container flex bottom={6} style={{marginTop: "3rem"}}>
                <div style={{ width: '100%' }}>
                    <h2 style={{ marginBottom: "1.5rem" }}>Piano + Singing</h2>
                    <p style={{ marginBottom: '1.5rem' }}>
                        I played piano at the <a href="https://www.youtube.com/embed/PxcOJ6X9Yh0">Pacific Northwest School of Music</a> with Sydney Han Lee for 13 years! My maintained repertoire includes:
                    </p>
                    <ul style={{ 
                        listStyleType: 'none',
                        padding: 0,
                        margin: '0 0 2rem 0'
                    }}>
                        <li style={{ marginBottom: '0.75rem' }}>• Ballade No. 3, Chopin</li>
                        <li style={{ marginBottom: '0.75rem' }}>• <u><a href="https://www.youtube.com/watch?v=iXBM4y0IhHA">Clair de Lune, Debussy</a></u></li>
                        <li style={{ marginBottom: '0.75rem' }}>• Arabesque No. 1, Debussy</li>
                    </ul>
                    <p>
                        I sang with the <a href="https://www.youtube.com/embed/cOMm34OoviY"><u>Radcliffe Choral Society</u></a> as a soprano.
                    </p>
                </div>
            </Container>
        </Container>
    );
}

// const PopUp = (props) => {
//     const [open, setOpen] = useState(false);

//     const toggle = () => {
//         setOpen(!open);
//     }

//     return (
//         <Fade direction="top" duration={1000} triggerOnce cascade>
//             <CaseLink target={props.newTab ? '_blank' : null}>
//                 {!open && <CaseStudyContainerList color={props.color} favorite={props.tags ? props.tags.includes("favorite") : false}>
//                     <CaseStudyContentList onClick={toggle} styles={{transition: "height .25s linear"}}>
//                         <ContainerList flexRow leftAlign>
//                             <h5 style={{marginTop: "auto", marginBottom: "auto"}}>{props.title}</h5>
//                             {props.title}
//                         </ContainerList>
//                     </CaseStudyContentList>
//                 </CaseStudyContainerList>}
//                 {open && <CaseStudyContainer color={props.color} favorite={props.tags ? props.tags.includes("favorite") : false}>
//                     <CaseStudyContent onClick={toggle} styles={{transition: "height .25s linear"}}>
//                     <section className="twitterContainer">
//                         <div className="twitter-embed">
//                         <blockquote class="twitter-tweet"><p lang="es" dir="ltr">▶️<a href="https://twitter.com/mitmagob?ref_src=twsrc%5Etfw">@mitmagob</a> se ha reunido con el Instituto de Tecnología de Massachusetts (MIT), el Consorcio Regional de Transportes de Madrid y la <a href="https://twitter.com/La_UPM?ref_src=twsrc%5Etfw">@La_UPM</a> para intercambiar experiencias de la aplicación de inteligencia artificial y tecnologías bigdata al análisis de la movilidad. <a href="https://t.co/dKyhw4vwXZ">pic.twitter.com/dKyhw4vwXZ</a></p>&mdash; Ministerio Transportes, Movilidad y A. Urbana (@mitmagob) <a href="https://twitter.com/mitmagob/status/1627694686088445952?ref_src=twsrc%5Etfw">February 20, 2023</a></blockquote>
//                         </div>
//                     </section>
//                     </CaseStudyContent>
//                 </CaseStudyContainer>}
//             </CaseLink>
//         </Fade>
//     );
// }

export default Resume;
